# GraphQL mutation to create a slack automation
#import "../fragments/sales-automation-stage.graphql"

mutation CreateOpenLeadSlackMessage(
    $openLeadSlackMessage: CreateOpenLeadSlackMessageInputFieldInput!
) {
    createOpenLeadSlackMessage(input: {openLeadSlackMessage: $openLeadSlackMessage}) {
        stage {
            ...SalesAutomationStage
        }
    }
}
